import React from 'react';
import HeroSection from '../components/home/HeroSection';
import TrustBar from '../components/home/TrustBar';
import ProblemSection from '../components/home/ProblemSection';
import HowItWorks from '../components/home/HowItWorks';
import FeaturesSection from '../components/home/FeaturesSection';
import SecurityStrip from '../components/home/SecurityStrip';
import FounderNote from '../components/home/FounderNote';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <TrustBar />
      <ProblemSection />
      <HowItWorks />
      <FeaturesSection />
      <SecurityStrip />
      <FounderNote />
      <CTASection />
    </>
  );
};

export default HomePage;
